import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link, Redirect, Route } from 'react-router-dom';
import ActivePollList from '../AdminPoll/PollTabs/ActivePollList';
import moment from 'moment';
import CourseListProfessors from './CourseList';


export default class PollList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            pollList: []

        };
    }
    componentDidMount() {
        localStorage.removeItem('courseId');
        localStorage.removeItem('spId');
        localStorage.removeItem('poll');
        localStorage.removeItem('organizationalUnitEmployeeId');
        localStorage.removeItem('courseImplementationGroupId');
        axios.get('questionnaire/staff/3/')
            .then(res => {
                const pollList = res.data.reverse();
                this.setState({ pollList, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch poll statuses.');
            });
    }

    // componentWillMount() {
    //
    //     axios.get('/questionnaire/get-statuses/')
    //         .then(res => {
    //             const statuses = res.data.map(el => ({
    //                 value: el.id,
    //                 key: el._key,
    //                 text: el.name
    //             }));
    //             this.setState({ statuses, loader: true });
    //         })
    //         .catch(err => {
    //             console.log('Failed to fetch poll statuses.');
    //         });
    // }
    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.pollList;
    }

    render() {
        // const FadeIn = styled.div`animation: 1s ${keyframes`${fadeIn}`}`;
        if (this.state.showResults === true) {
            return (<FormattedMessage id="route.pollCourses">
                {(msg) => (<Redirect push to={{ pathname: msg }} />)}
            </FormattedMessage>);
        }
        return (

            <div>
                <Header as="h2"> <FormattedMessage id="poll.polls" /> </Header>
                <Segment.Group clearing raised >
                    <Segment> <Header as="h3"> <FormattedMessage id="poll.overview" /> </Header></Segment>

                    <Segment>
                        {this.state.loading ? <Loader active inline="centered" /> :
                            this.getDataToRender().length ? <Table celled selectable compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell >
                                            <FormattedMessage id="poll.title" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell >
                                            <FormattedMessage id="poll.type" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={2}>
                                            <FormattedMessage id="poll.startDate" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell width={2}>
                                            <FormattedMessage id="poll.endDate" />
                                        </Table.HeaderCell >


                                        <Table.HeaderCell width={2}></Table.HeaderCell>


                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {this.getDataToRender().map((el, index) =>
                                        (<Table.Row
                                            key={index}
                                            onClick={(e) => {
                                                let poll = {
                                                    pollId: el.id,
                                                    pollName: el.name,
                                                    pollType: el.questionnaireType.id,
                                                    pollTypeKey: el.questionnaireType._key,
                                                    pollStatus: el.questionnaireStatus.id,
                                                    showAddQuestion: false
                                                };
                                                localStorage.setItem('poll', JSON.stringify(poll));
                                                this.setState({ showResults: true });
                                            }}
                                        >
                                            <Table.Cell verticalAlign="middle">
                                                {el.name}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.questionnaireType.name}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" >
                                                {moment(el.activationDate).format('D. M. YYYY.')}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" >
                                                {moment(el.endDate).format('D. M. YYYY.')}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" textAlign="center" width={2}>
                                                {/* link */}

                                                <Button
                                                    onClick={() => {
                                                        let poll = {
                                                            pollId: el.id,
                                                            pollName: el.name,
                                                            pollType: el.questionnaireType.id,
                                                            pollStatus: el.questionnaireStatus.id,
                                                            showAddQuestion: false
                                                        };
                                                        localStorage.setItem('poll', JSON.stringify(poll));
                                                        this.setState({ showResults: true });
                                                    }}

                                                    basic="true"
                                                    color="blue"
                                                    size="small"
                                                >  <FormattedMessage id="common.courses" />
                                                </Button>


                                            </Table.Cell>
                                        </Table.Row>))}
                                </Table.Body>
                            </Table> : 'Trenutno nema arhiviranih anketa.'
                        }</Segment>

                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/ProfessorPoll/PollList.js